{
  "loading": "Įkeliama...",
  "loadingMore": "Įkeliama daugiau..."
}
